export default {
  'component.tagSelect.expand': 'Развернуть',
  'component.tagSelect.collapse': 'Свернуть',
  'component.tagSelect.all': 'Все',
  'component.themeToggle.switchToLight': 'Переключить на светлую тему',
  'component.themeToggle.switchToDark': 'Переключить на темную тему',
};
